export const loginModalType = {
  LOGIN_MODAL_SHOW: 'LOGIN_MODAL_SHOW',
  LOGIN_MODAL_HIDE: 'LOGIN_MODAL_HIDE',
}